// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__39GQi","inputWrap":"CustomTip_inputWrap__2kvhA"};